import { createStyles } from '@material-ui/core/styles';

export const styles = () =>
  createStyles({
    // Callers pass their own clipping (ellipsis or line clamp) through classes.root.
    root: {},
  });
